export enum LanguageKey {
  hebrew = 'he',
  english = 'en'
}
